import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { DashboardUtils } from "../../../dashboard_utils";

export function TimeFinderBase() {
	const history = useHistory();
	const { server_id } = useParams<{ server_id: string }>();

	return (
		<div className="mt-4 flex flex-col items-center">
			<div className="flex flex-col space-y-6">
				<DashboardUtils.CreateOptionsButton
					button_name="Create New Time Finder"
					mobile_button_name="Create New"
					icon={
						<i className="fas fa-plus-circle fa-lg title-icon"></i>
					}
					on_click={() =>
						history.push(
							`/dashboard/${server_id}/time-finder/create`
						)
					}
					needs_history={false}
				/>

				<DashboardUtils.CreateOptionsButton
					button_name="View Previous Time Finders"
					mobile_button_name="View Previous"
					icon={<i className="fas fa-history fa-lg title-icon"></i>}
					on_click={() =>
						history.push(`/dashboard/${server_id}/time-finder/view`)
					}
					needs_history={false}
				/>
			</div>
		</div>
	);
}
